import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';

function useOpenTaskMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return taskId => mutater(entry => {
    const taskEntry = entry.data.tasks[taskId] ??= makeInitialOpgavekompleksetTaskEntry(data, taskId);
    taskEntry.state.opened = true;
    taskEntry.state.skipped = false;
    return entry;
  });
}

export { useOpenTaskMutation };
//# sourceMappingURL=task.open.js.map
